/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Val_JeansInputs */

const en_val_jeans = /** @type {(inputs: Val_JeansInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jeans`)
};

const es_val_jeans = /** @type {(inputs: Val_JeansInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pantalones vaqueros`)
};

const fr_val_jeans = /** @type {(inputs: Val_JeansInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jeans`)
};

const de_val_jeans = /** @type {(inputs: Val_JeansInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jeans`)
};

const ja_val_jeans = /** @type {(inputs: Val_JeansInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ジーンズ`)
};

const zh_val_jeans = /** @type {(inputs: Val_JeansInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`牛仔裤`)
};

const ar_val_jeans = /** @type {(inputs: Val_JeansInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`جينز`)
};

const id_val_jeans = /** @type {(inputs: Val_JeansInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jeans`)
};

const it_val_jeans = /** @type {(inputs: Val_JeansInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jeans`)
};

const ru_val_jeans = /** @type {(inputs: Val_JeansInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Джинсы`)
};

const pt_val_jeans = /** @type {(inputs: Val_JeansInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jeans`)
};

const ko_val_jeans = /** @type {(inputs: Val_JeansInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`청바지`)
};

/**
* | output |
* | --- |
* | "Jeans" |
*
* @param {Val_JeansInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const val_jeans = /** @type {((inputs?: Val_JeansInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Val_JeansInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_val_jeans(inputs)
	if (locale === "es") return es_val_jeans(inputs)
	if (locale === "fr") return fr_val_jeans(inputs)
	if (locale === "de") return de_val_jeans(inputs)
	if (locale === "ja") return ja_val_jeans(inputs)
	if (locale === "zh") return zh_val_jeans(inputs)
	if (locale === "ar") return ar_val_jeans(inputs)
	if (locale === "id") return id_val_jeans(inputs)
	if (locale === "it") return it_val_jeans(inputs)
	if (locale === "ru") return ru_val_jeans(inputs)
	if (locale === "pt") return pt_val_jeans(inputs)
	return ko_val_jeans(inputs)
});